import { credentialToJson, toWebAuthnCreationOptions, type CognitoApi } from "./cognito-api";

/** The browser's create ceremony: `navigator.credentials.create`, or the mock's in mock builds. */
export type CreateCredential = (options: CredentialCreationOptions) => Promise<Credential | null>;

const browserCreate: CreateCredential = (options) => navigator.credentials.create(options);

/**
 * Enrolls a passkey for the person whose access token this is (R6: one ceremony): Cognito's creation options, the
 * browser's prompt, the credential back to Cognito. Account › Security's "Add a passkey" and first sign-in's
 * "Add a passkey" (gairm/lms#393) both run this. Rejects as the browser does — `NotAllowedError` when the person
 * closes the prompt, `NotSupportedError` where nothing here can make one — or with Cognito's error. `signal` closes the
 * browser's prompt (first sign-in's "Not now" while it is open); an aborted enrollment rejects and sends nothing more
 * to Cognito.
 */
export async function enrollPasskey(api: Pick<CognitoApi, "startPasskey" | "completePasskey">, accessToken: string, create: CreateCredential = browserCreate, signal?: AbortSignal): Promise<void> {
  const start = await api.startPasskey(accessToken);
  signal?.throwIfAborted();
  const created = await create({ ...toWebAuthnCreationOptions(start.CredentialCreationOptions), ...(signal ? { signal } : {}) });
  signal?.throwIfAborted();
  await api.completePasskey(accessToken, credentialToJson(created));
}
